import styled from 'styled-components';

const TabLayoutContainer = styled.div`
  display: grid;
  grid-template-rows: 67px minmax(0, 1fr);
  flex: 1;
`;

export default TabLayoutContainer;